export const GET_BY_NAME = 'GET_BY_NAME';
export const GET_ALL_POKEMON = 'GET_ALL_POKEMON';
export const GET_TYPE = 'GET_TYPE';
export const FILTER_BY_CREATED = 'FILTER_BY_CREATED';
export const ORDER_BY = 'ORDER_BY';
export const CREATE_POKEMON = 'CREATE_POKEMON';
export const FILTER_BY_TYPE = 'FILTER_BY_TYPE';
export const POKEMON_DETAIL = 'POKEMON_DETAIL';
export const CLEAN_POKEMON = 'CLEAN_POKEMON';
